import { render, staticRenderFns } from "./recordPlayer.vue?vue&type=template&id=be32612a&scoped=true"
import script from "./recordPlayer.vue?vue&type=script&lang=js"
export * from "./recordPlayer.vue?vue&type=script&lang=js"
import style0 from "./recordPlayer.vue?vue&type=style&index=0&id=be32612a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be32612a",
  null
  
)

export default component.exports